import React, { type MutableRefObject } from "react";
import { view } from "@orderofchaos/mvvm";
import styles from "./Input.module.css";
import Icon, { type IconNames, type IconSize } from "../Icon/Icon";
import { InputViewModel } from "./InputViewModel";

export interface InputOnChangeData extends InputProps {
  value: string;
}
export type InputSize = IconSize;
export interface InputProps {
  label?: string; // label
  labelClassName?: string;
  value?: string; // value
  className?: string; // className
  textAlign?: "start" | "center" | "end"; // textAlign
  iconName?: IconNames; // iconName
  dirty?: boolean; // dirty
  isValid?: boolean; // isValid
  onIconClick?: () => unknown; // onIconClick
  getRef?: MutableRefObject<HTMLInputElement | null>; // getRef
  iconPosition?: "left" | "right"; // iconPosition
  size?: InputSize;
  disabled?: boolean;
  onChange?: (
    event: React.ChangeEvent<HTMLInputElement>,
    data: InputOnChangeData,
  ) => void; // onChange
  type?: string; // type
  id?: string; // id
  name?: string; // name
  placeholder?: string; // placeholder
  autoFocus?: boolean; // autoFocus
  autocomplete?: string; // autocomplete
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  [key: string]: unknown;
}

const Input: React.FC<InputProps> = view(InputViewModel)<InputProps>(({
  viewModel: {
    label,
    value,
    classes,
    onFocus,
    onBlur,
    onInputChange,
    disabled,
    inputElementProps,
    getRef,
    labelClasses,
    iconName,
    size,
    iconElementTag,
    onIconClick,
  },
}) => {
  return (
    <div className={classes}>
      <input
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={onInputChange}
        value={value}
        disabled={disabled}
        {...inputElementProps}
        ref={getRef}
      />
      {label ? <label className={labelClasses}>{label}</label> : null}
      {iconName ? (
        <Icon
          name={iconName}
          size={size}
          as={iconElementTag}
          className={styles.icon}
          onClick={onIconClick}
        />
      ) : null}
    </div>
  );
});

export default Input;
